// extracted by mini-css-extract-plugin
export default {"pc":"common_pc__ubgDp","sp":"common_sp__brBvj"};